<div
    class="font-inter w-full h-full bg-[linear-gradient(359deg,_#FFF_83.33%,_var(--latte-50,_#F9F5F0)_99.08%)]">
    <div class="w-full h-full p-4">
        <div class="w-full h-full flex flex-col items-center justify-start gap-4">
            <div class="w-full text left font-inter text-16 text-bluegrey font-semibold"
                >My schedule</div
            >
            <div class="w-full flex justify-between items-center gap-1">
                <p-button
                    (click)="showUpcoming = true"
                    [outlined]="!showUpcoming"
                    class="flex-1"
                    styleClass="w-full"
                    size="small"
                    severity="secondary">
                    <div class="flex items-center gap-2">
                        <fa-icon [icon]="faCrystalBall" />
                        <span class="font-bold whitespace-nowrap m-0"> Upcoming </span>
                    </div>
                </p-button>

                <p-button
                    (click)="showUpcoming = false"
                    [outlined]="showUpcoming"
                    class="flex-1"
                    styleClass="w-full"
                    classes="w-full"
                    size="small"
                    severity="secondary">
                    <div class="flex items-center gap-2">
                        <fa-icon [icon]="faScroll" />
                        <span class="font-bold whitespace-nowrap m-0"> Past </span>
                    </div>
                </p-button>
            </div>
            <div class="w-full h-[calc(100%_-_101px)]">
                <p-scrollPanel #mySessionsScrollPanel [style]="{ width: '100%', height: '100%' }">
                    <div
                        class="xh-full xmin-h-full flex flex-col w-full justify-start items-center">
                        @if (showUpcoming) {
                            @for (day of sessionList; track day.dateLabel) {
                                <div
                                    class="w-full text-left text-14 text-bluegrey-2 font-semibold mb-4 first:mt-0 mt-6"
                                    >{{ day.dateLabel }}</div
                                >
                                <div class="w-full flex flex-col gap-2">
                                    @for (session of day.sessions; track session.sessionTime) {
                                        <fm-booked-session-tile
                                            [sessionInfo]="session"
                                            timezone="US/Eastern"
                                            width="232"
                                            height="92"
                                            class="rounded-lg" />
                                    }
                                </div>
                            }
                        } @else {
                            @for (pastDay of sessionListPast; track pastDay.dateLabel) {
                                <div
                                    class="w-full text-left text-14 text-bluegrey-2 font-semibold mb-4 first:mt-0 mt-6"
                                    >{{ pastDay.dateLabel }}</div
                                >
                                <div class="w-full flex flex-col gap-2">
                                    @for (session of pastDay.sessions; track session.sessionTime) {
                                        <fm-booked-session-tile
                                            [sessionInfo]="session"
                                            timezone="US/Eastern"
                                            width="232"
                                            height="80"
                                            class="rounded-lg" />
                                    }
                                </div>
                            }
                        }
                    </div>
                </p-scrollPanel>
            </div>
        </div>
    </div>
</div>
